import { Component } from '@angular/core';
import { FooterOneComponent } from '@src/app/core/shared/bottom/footer-one/footer-one.component';

declare var $: any;
// import * as $ from 'jquery';
@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [FooterOneComponent],
})
export class FooterComponent  {
}
